import { Clock } from 'lucide-react';
import { BasePopup } from '../BasePopup';

interface ComingSoonPopupProps {
  deviceName: string;
  onClose: () => void;
}

export function ComingSoonPopup({ deviceName, onClose }: ComingSoonPopupProps) {
  return (
    <BasePopup
      onClose={onClose}
      title="Coming Soon!"
      icon={<Clock className="h-6 w-6" />}
      className="max-w-md"
      variant="analytics"
    >
      <div className="p-6">
        <div className="mb-4 flex items-center justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[var(--anl-surface-elev)]">
            <Clock className="h-8 w-8 text-[var(--anl-accent)]" />
          </div>
        </div>

        <div className="text-center">
          <p className="mb-4 text-[var(--anl-text)]">
            {deviceName} integration is currently in development and will be available soon.
          </p>
          <p className="text-sm text-[var(--anl-text-muted)]">
            We're working hard to bring you more device integrations. Stay tuned for updates!
          </p>
        </div>

        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="rounded-lg bg-[var(--anl-accent)] px-6 py-2 text-[var(--anl-text)] transition-colors hover:opacity-90"
          >
            Got it
          </button>
        </div>
      </div>
    </BasePopup>
  );
}
